module.exports = __webpack_public_path__ + "img/intro.026a72a9.jpg";